import { Component, OnInit } from '@angular/core';
import { IServiceDeliveryGroup } from '../../interfaces/service-delivery-group';
import { OrganisationsService } from '../../services/organisations.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { BBWTMessageService } from '../../services/message.service';

@Component({
  selector: 'app-service-delivery-groups',
  styleUrls: ['./service-delivery-groups.component.scss'],
  templateUrl: './service-delivery-groups.component.html',
})
export class ServiceDeliveryGroupsComponent implements OnInit {
  constructor(
    private organisationService: OrganisationsService,
    private fb: UntypedFormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: BBWTMessageService,
  ) {}

  serviceGroups: IServiceDeliveryGroup[];
  selectedGroup: IServiceDeliveryGroup;
  showAddDialog = false;

  form: UntypedFormGroup;

  ngOnInit() {
    this.loadGroups();

    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      telephone: ['', Validators.required],
    });
  }

  loadGroups() {
    this.organisationService.getServiceDeliveryGroups().then((result) => {
      this.serviceGroups = result;
    });
  }

  addGroup() {
    this.showAddDialog = true;
  }

  deleteGroup(entry: IServiceDeliveryGroup) {
    this.confirmationService.confirm({
      message: 'Ok to delete this service group?',
      accept: () => {
        this.organisationService
          .deleteServiceDeliveryGroup(entry.id)
          .then(() => {
            this.loadGroups();
          })
          .catch((error) => {
            this.messageService.ShowError(
              'Error',
              'Cannot delete a group when associated with one or more customers',
            );
          });
      },
    });
  }

  cellEdit(item: IServiceDeliveryGroup) {
    console.log('Group edit: ', item);
    this.organisationService.updateServiceDeliveryGroup(item).then(() => {
      //this.loadGroups();
    });
  }

  addNewGroup() {
    if (!this.form.valid) {
      return;
    }

    this.showAddDialog = false;

    let dto: IServiceDeliveryGroup = { ...this.form.value };

    this.organisationService.addServiceDeliveryGroup(dto).then(() => {
      this.loadGroups();
    });
  }
}
